import { defineStyle } from "@chakra-ui/react";

export const questionLayoutStyles = () => {
  return {
    answerLayoutContainer: defineStyle({
      marginLeft: { base: "10px", md: "14px", lg: "10px" },
    }),
  };
};
